import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, FormControl, Grid, Stack, TextField } from "@mui/material";
import JumboCardQuick from '@jumbo/components/JumboCardQuick';
import { putUpdateObjectApi } from "api/general";
import { swal_error, swal_success, swal_warning } from "app/utils/appHelpers";
import { MEETINGS } from "app/utils/constants/customConstant";
import {
    updateMeetingInReduxList,
    updateMeetingListAction,
    getMeetingListFromStateByPageType
} from "app/utils/meetingReduxHelpers";
import { getUrlBAYKTRApi } from "api/b.ayk.tr.Service";
import Swal from "sweetalert2";

function VideoLinkCard({ meeting, setVideoLinkDialogStatus }) {
    const dispatch = useDispatch();
    const [meetingUrl, setMeetingUrl] = useState(meeting.meetingUrl || '');
    const [error, setError] = useState(false);
    const [message, setMessage] = useState('');
    const authUser = useSelector(state => state.auth.authUser);

    const [currentMeetingList, setCurrentMeetingList] = useState([]);
    const meetingStore = useSelector((state) => state.meeting);

    useEffect(() => {
        setCurrentMeetingList(getMeetingListFromStateByPageType({ meetingStore }));
    }, [meetingStore.allMeetingList, meetingStore.pageType]);


    useEffect(() => {
        setMeetingUrl(meeting.meetingUrl || '');
    }, [meeting]);

    const handleSave = async () => {

        if (meetingUrl === meeting.meetingUrl) {

            Swal.fire({
                position: 'center',
                icon: 'warning',
                title: 'Herhangi bir değişiklik yapmadınız',
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    container: 'swal-container-custom'
                },
            });
            return;
        }

        setError(false);
        setMessage('');

        const { user, users, decisionCount, isThereReminder, ...meetingWithoutRelations } = meeting;

        let meetingShortUrl = null;
        let updatedMeetingObj = {};
        if (meetingUrl !== "") {
            const resAyk = await getUrlBAYKTRApi(meetingUrl)
            meetingShortUrl = resAyk.short;

        }

        updatedMeetingObj = {
            ...meetingWithoutRelations,
            meetingUrl: meetingUrl,
            meetingShortUrl: meetingShortUrl,
            adminUserId: authUser.id
        };


        const result = await putUpdateObjectApi(MEETINGS, updatedMeetingObj);
        setVideoLinkDialogStatus(false);



        if (result.status) {
            const updatedMeeting = {
                ...meeting,
                user,
                users,
                decisionCount,
                meetingUrl: meetingUrl,
                meetingShortUrl: meetingShortUrl,
                isThereReminder,
                adminUserId: authUser.id
            };

            const newList = updateMeetingInReduxList(currentMeetingList, updatedMeeting);
            dispatch(updateMeetingListAction(newList));

            swal_success('Video linki başarıyla güncellendi', 1500);
        } else {
            swal_error('Güncelleme başarısız, tekrar deneyin', 1500);
        }
    };

    const handleDelete = async () => {
        setError(false);
        setMessage('');

        const { user, users, decisionCount, isThereReminder, ...meetingWithoutRelations } = meeting;

        const updatedMeetingObj = {
            ...meetingWithoutRelations,
            meetingUrl: '',
            meetingShortUrl: null,
            teamsId: '',
            adminUserId: authUser.id
        };

        const result = await putUpdateObjectApi(MEETINGS, updatedMeetingObj);
        setVideoLinkDialogStatus(false);

        if (result.status) {
            const updatedMeeting = {
                ...meeting,
                user,
                users,
                decisionCount,
                meetingUrl: '',
                meetingShortUrl: null,
                teamsId: '',
                isThereReminder,
                adminUserId: authUser.id
            };

            const newList = updateMeetingInReduxList(currentMeetingList, updatedMeeting);
            dispatch(updateMeetingListAction(newList));

            swal_success('Video linki silindi', 1500);
        } else {
            swal_error('Silme başarısız, tekrar deneyin', 1500);
        }
    };

    return (
        <JumboCardQuick>
            <Grid container spacing={1}>
                <Grid item xs={10}>
                    <FormControl fullWidth>
                        <TextField
                            label="Toplantı Bağlantısı"
                            value={meetingUrl}
                            size="medium"
                            // required
                            // error={error}
                            // helperText={error ? 'Bu alan zorunludur' : ''}
                            onChange={(e) => setMeetingUrl(e.target.value)}
                        />
                    </FormControl>
                    {message && <p style={{ textAlign: 'center', color: error ? 'red' : 'green' }}>{message}</p>}
                </Grid>
                <Grid item xs={2}>
                    <Stack direction="row" spacing={1} justifyContent="flex-end">
                        <Button variant="outlined" size="large" color="success" onClick={handleSave}>
                            Ekle
                        </Button>
                        <Button variant="outlined" size="large" color="error" onClick={handleDelete}>
                            Sil
                        </Button>
                    </Stack>
                </Grid>
            </Grid>
        </JumboCardQuick>
    );
}

export default VideoLinkCard;
